// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"df4711a02e47dfb4","8587":"260f728284d2fef3"}[chunkId] + ".css";
};